import { Select } from 'antd';
import { EEntity } from '@/services/dynamics/enums/entity.enum';
import { DynRelatedToData } from '@/services/dynamics/interfaces/relate-to-info.interface';
import { showRelateToEntityText } from '@/shared/helpers/relate-to-name.helper';
import { IRelateTo } from '@/shared/interfaces/relate-to.interface';
import { SelectValueType } from '@/shared/types/FormSelect';
import './CallPanel.scss';

const { Option } = Select;
const optionsRender = () => {
  const entities = [
    EEntity.ACCOUNT,
    EEntity.CONTACT,
    EEntity.LEAD,
    EEntity.CASE,
    EEntity.OPPORTUNITY,
    EEntity.CAMPAIGN,
    EEntity.QUOTE,
    EEntity.INVOICE,
    EEntity.ORDER,
  ];

  return entities.map((e, i) => {
    return (
      <Option key={i} value={e}>
        {showRelateToEntityText(e)}
      </Option>
    );
  });
};

interface IProps {
  relatedToData: DynRelatedToData;
  onSelectEntityType: (value: EEntity) => void;
  relatedEntityOptions: SelectValueType[];
  onEntitySelected: (relateTo: IRelateTo) => void;
  onSearchEntityOptions: (text: string) => void;
}

export const RelateBlock = ({
  relatedToData,
  onSelectEntityType,
  relatedEntityOptions,
  onEntitySelected,
  onSearchEntityOptions,
}: IProps) => {
  return (
    <div className="note__relate-to">
      <div className="main-text note__header">Relate to</div>
      <div className="note__relate-to-controls">
        <Select
          className="note__select-entity"
          data-testid="select-relate-to-entity"
          showSearch
          placeholder="Select an entity"
          optionFilterProp="children"
          value={relatedToData?.type || null}
          onChange={onSelectEntityType}
          filterOption={(input, option) =>
            (option?.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {optionsRender()}
        </Select>
        {relatedToData?.type && (
          <Select
            showSearch
            labelInValue
            data-testid="select-relate-to-option"
            className="note__relate-options"
            options={relatedEntityOptions}
            allowClear
            showArrow={false}
            value={
              relatedEntityOptions.find(
                (item) => item.value === relatedToData.id,
              ) || null
            }
            onSelect={onEntitySelected}
            placeholder="Please choose an entity name"
            filterOption={false}
            onSearch={onSearchEntityOptions}
          />
        )}
      </div>
    </div>
  );
};
